import { marked } from 'marked';
import memoize from 'lodash/memoize';
import { DefaultRenderer } from './DefaultRenderer';
import { ArticleRenderer } from './ArticleRenderer';
export const textIframeTransform = (text) => text
    .replace(/<iframe.* src=".*youtube.com\/embed\/([^"]+)".*><\/iframe>/gi, '[youtube-video $1]')
    .replace(/<iframe.* src=".*open.spotify.com\/embed\/([^"?]+).*[^extra-wide]><\/iframe>/gi, (_, p1) => `[play-button spotify:${p1.replace('/', ':')}]`);
export const defaultMarkdown = memoize(text => marked(text, { renderer: new DefaultRenderer() }));
export const articleMarkdown = memoize((text, initialDropcap = false) => {
    const renderer = new ArticleRenderer();
    renderer.initialDropcap = initialDropcap;
    const txt = textIframeTransform(text);
    return marked(txt, { renderer }).replace(/<p><picture>/gi, '<p class="article-picture"><picture>');
});
